import {
  HeadingTitle,
  HighLightWrapper,
  ParagraphBlock,
  ParagraphTitle,
  SecondHeadingTitle,
  TextBlock,
} from "@/components/Typography";

import TitleImage from "@/components/shared/TitleImage";
import { handleLangData } from "@/i18n";
import propaganda from "/Img/country/Vietnam/propaganda.jpg";
import hoianBoatNight from "/Img/country/Vietnam/hoianBoatNight.jpg";
import hoianCycling from "/Img/country/Vietnam/hoianCycling.jpg";
import hcmStreetFood from "/Img/country/Vietnam/hcmStreetFood.jpg";
import cuchiShootingRange from "/Img/country/Vietnam/cuchiShootingRange.jpg";
import warMuseum from "/Img/country/Vietnam/warMuseum.jpg";
import marbleMountain from "/Img/country/Vietnam/marbleMountain.jpg";
import hueSaltedEggSnail from "/Img/country/Vietnam/hueSaltedEggSnail.jpg";
import sleeperBus1 from "/Img/country/Vietnam/sleeperBus1.jpg";
import sleeperBus2 from "/Img/country/Vietnam/sleeperBus2.jpg";
import phongNhaView from "/Img/country/Vietnam/phongNhaView.jpg";
import lotusNoodle from "/Img/country/Vietnam/lotusNoodle.jpg";
import lotusClaypot from "/Img/country/Vietnam/lotusClaypot.jpg";
import phongNhaKayak from "/Img/country/Vietnam/phongNhaKayak.jpg";
import phongNhaDuckFarm from "/Img/country/Vietnam/phongNhaDuckFarm.jpg";
import ninhBinhHoaLu from "/Img/country/Vietnam/ninhBinhHoaLu.jpg";
import muaCaveGoat from "/Img/country/Vietnam/muaCaveGoat.jpg";
import muaCaveClimb from "/Img/country/Vietnam/muaCaveClimb.jpg";
import muaCaveView from "/Img/country/Vietnam/muaCaveView.jpg";
import trangAnBoat from "/Img/country/Vietnam/trangAnBoat.jpg";
import ninhBinhGolf from "/Img/country/Vietnam/ninhBinhGolf.jpg";
import sapaHomestayView from "/Img/country/Vietnam/sapaHomestayView.jpg";
import sapaLandscape from "/Img/country/Vietnam/sapaLandscape.jpg";
import sapaHomestayRoom from "/Img/country/Vietnam/sapaHomestayRoom.jpg";
import sapaMist from "/Img/country/Vietnam/sapaMist.jpg";
import fansipanSummit from "/Img/country/Vietnam/fansipanSummit.jpg";
import hanoiPropaganda from "/Img/country/Vietnam/hanoiPropaganda.jpg";
import hanoiOysters from "/Img/country/Vietnam/hanoiOysters.jpg";
import hanoiXaShuNoodle from "/Img/country/Vietnam/hanoiSalad.jpg";
import hanoi4Ppizza from "/Img/country/Vietnam/hanoi4Ppizza.jpg";

const VietnamItinerary = (currentLang: string) => {
  const t = handleLangData(currentLang);
  return (
    <>
      <TitleImage src={propaganda} titleImgText={t["vietnam.coverImg"]} />
      <ParagraphBlock>{t["vietnam.intro"]}</ParagraphBlock>

      <HeadingTitle>{t["vietnam.overview.title"]}</HeadingTitle>
      <ParagraphBlock>
        <ParagraphTitle>{t["vietnam.overview.stop1"]}</ParagraphTitle>
        <ParagraphTitle>{t["vietnam.overview.stop2"]}</ParagraphTitle>
        <ParagraphTitle>{t["vietnam.overview.stop3"]}</ParagraphTitle>
        <ParagraphTitle>{t["vietnam.overview.stop4"]}</ParagraphTitle>
        <ParagraphTitle>{t["vietnam.overview.stop5"]}</ParagraphTitle>
        <ParagraphTitle>{t["vietnam.overview.stop6"]}</ParagraphTitle>
        <ParagraphTitle>{t["vietnam.overview.stop7"]}</ParagraphTitle>
      </ParagraphBlock>

      <HeadingTitle>{t["vietnam.hcm.title"]}</HeadingTitle>
      <ParagraphBlock>{t["vietnam.hcm.arrival"]}</ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.hcm.streetFood.title"]}</SecondHeadingTitle>
        {t["vietnam.hcm.streetFood.p"]}
        <HighLightWrapper>{t["vietnam.hcm.streetFood.highlight"]}</HighLightWrapper>
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.hcm.history.title"]}</SecondHeadingTitle>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.hcm.warMuseum.title"]}</ParagraphTitle>
          <TitleImage src={warMuseum} titleImgText={t["vietnam.hcm.warMuseum.img"]} />
          {t["vietnam.hcm.warMuseum.p"]}
        </ParagraphBlock>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.hcm.palace.title"]}</ParagraphTitle>
          {t["vietnam.hcm.palace.p"]}
        </ParagraphBlock>
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.hcm.cuChi.title"]}</SecondHeadingTitle>
        {t["vietnam.hcm.cuChi.p"]}
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.hcm.cuChi.range.title"]}</ParagraphTitle>
          <TitleImage src={cuchiShootingRange} titleImgText={t["vietnam.hcm.cuChi.range.img"]} />
          {t["vietnam.hcm.cuChi.range.p"]}
        </ParagraphBlock>
        <HighLightWrapper>{t["vietnam.hcm.cuChi.highlight"]}</HighLightWrapper>
      </ParagraphBlock>

      <HeadingTitle>{t["vietnam.hoian.title"]}</HeadingTitle>
      <ParagraphBlock>{t["vietnam.hoian.arrival"]}</ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.hoian.nightTour.title"]}</SecondHeadingTitle>
        {t["vietnam.hoian.nightTour.intro"]}
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.hoian.nightTour.boat.title"]}</ParagraphTitle>
          {t["vietnam.hoian.nightTour.boat.p"]}
          <TitleImage src={hoianBoatNight} titleImgText={t["vietnam.hoian.nightTour.boat.img"]} />
          <HighLightWrapper>{t["vietnam.hoian.nightTour.boat.highlight"]}</HighLightWrapper>
        </ParagraphBlock>
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.hoian.cycling.title"]}</SecondHeadingTitle>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.hoian.cycling.bike.title"]}</ParagraphTitle>
          <TitleImage src={hoianCycling} titleImgText={t["vietnam.hoian.cycling.bike.img"]} />
          {t["vietnam.hoian.cycling.bike.p"]}
        </ParagraphBlock>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.hoian.cycling.coconut.title"]}</ParagraphTitle>
          {t["vietnam.hoian.cycling.coconut.p"]}
        </ParagraphBlock>
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.hoian.stroll.title"]}</SecondHeadingTitle>
        {t["vietnam.hoian.stroll.p"]}
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.hoian.laBottega.title"]}</ParagraphTitle>
          {t["vietnam.hoian.laBottega.p"]}
        </ParagraphBlock>
      </ParagraphBlock>

      <HeadingTitle>{t["vietnam.hue.title"]}</HeadingTitle>
      <ParagraphBlock>
        {t["vietnam.hue.intro"]}
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.hue.transport.title"]}</ParagraphTitle>
          <ParagraphBlock>{t["vietnam.hue.transport.motorbike"]}</ParagraphBlock>
          <ParagraphBlock>{t["vietnam.hue.transport.car"]}</ParagraphBlock>
        </ParagraphBlock>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.hue.stops.title"]}</ParagraphTitle>
          <ParagraphBlock>
            <ParagraphTitle>{t["vietnam.hue.marble.title"]}</ParagraphTitle>
            <TitleImage src={marbleMountain} titleImgText={t["vietnam.hue.marble.img"]} />
            {t["vietnam.hue.marble.p"]}
          </ParagraphBlock>
          <ParagraphBlock>{t["vietnam.hue.haiVan"]}</ParagraphBlock>
          <ParagraphBlock>{t["vietnam.hue.langCo"]}</ParagraphBlock>
          <ParagraphBlock>{t["vietnam.hue.imperial"]}</ParagraphBlock>
        </ParagraphBlock>
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.hue.snail.title"]}</SecondHeadingTitle>
        <TitleImage src={hueSaltedEggSnail} titleImgText={t["vietnam.hue.snail.img"]} />
        {t["vietnam.hue.snail.p"]}
      </ParagraphBlock>

      <HeadingTitle>{t["vietnam.phongNha.title"]}</HeadingTitle>
      <ParagraphBlock>{t["vietnam.phongNha.arrival"]}</ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.phongNha.sleeperBus.title"]}</SecondHeadingTitle>
        <TitleImage src={sleeperBus1} titleImgText={t["vietnam.phongNha.sleeperBus.img1"]} />
        <TitleImage src={sleeperBus2} titleImgText={t["vietnam.phongNha.sleeperBus.img2"]} />
        {t["vietnam.phongNha.sleeperBus.p"]}
        <HighLightWrapper>{t["vietnam.phongNha.sleeperBus.highlight"]}</HighLightWrapper>
        <TitleImage src={phongNhaView} titleImgText={t["vietnam.phongNha.sleeperBus.viewImg"]} />
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.phongNha.caves.title"]}</SecondHeadingTitle>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.phongNha.paradise.title"]}</ParagraphTitle>
          {t["vietnam.phongNha.paradise.p"]}
        </ParagraphBlock>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.phongNha.caveTour.title"]}</ParagraphTitle>
          {t["vietnam.phongNha.caveTour.intro"]}
          <ParagraphBlock>{t["vietnam.phongNha.caveTour.step1"]}</ParagraphBlock>
          <ParagraphBlock>{t["vietnam.phongNha.caveTour.step2"]}</ParagraphBlock>
          <ParagraphBlock>{t["vietnam.phongNha.caveTour.step3"]}</ParagraphBlock>
          <ParagraphBlock>{t["vietnam.phongNha.caveTour.step4"]}</ParagraphBlock>
          <TitleImage src={phongNhaKayak} titleImgText={t["vietnam.phongNha.caveTour.img"]} />
          {t["vietnam.phongNha.caveTour.p"]}
          <HighLightWrapper>{t["vietnam.phongNha.caveTour.warning"]}</HighLightWrapper>
        </ParagraphBlock>
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.phongNha.outdoor.title"]}</SecondHeadingTitle>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.phongNha.darkCave.title"]}</ParagraphTitle>
          {t["vietnam.phongNha.darkCave.p"]}
        </ParagraphBlock>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.phongNha.cycling.title"]}</ParagraphTitle>
          {t["vietnam.phongNha.cycling.p"]}
        </ParagraphBlock>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.phongNha.duckFarm.title"]}</ParagraphTitle>
          <TitleImage src={phongNhaDuckFarm} titleImgText={t["vietnam.phongNha.duckFarm.img"]} />
          {t["vietnam.phongNha.duckFarm.p"]}
        </ParagraphBlock>
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.phongNha.lotus.title"]}</SecondHeadingTitle>
        <TitleImage src={lotusNoodle} titleImgText={t["vietnam.phongNha.lotus.img1"]} />
        <TitleImage src={lotusClaypot} titleImgText={t["vietnam.phongNha.lotus.img2"]} />
        {t["vietnam.phongNha.lotus.p"]}
        <HighLightWrapper>{t["vietnam.phongNha.lotus.highlight"]}</HighLightWrapper>
      </ParagraphBlock>

      <HeadingTitle>{t["vietnam.ninhBinh.title"]}</HeadingTitle>
      <ParagraphBlock>{t["vietnam.ninhBinh.arrival"]}</ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.ninhBinh.hoaLu.title"]}</SecondHeadingTitle>
        <TitleImage src={ninhBinhHoaLu} titleImgText={t["vietnam.ninhBinh.hoaLu.img"]} />
        {t["vietnam.ninhBinh.hoaLu.p"]}
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.ninhBinh.nature.title"]}</SecondHeadingTitle>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.ninhBinh.trangAn.title"]}</ParagraphTitle>
          <TitleImage src={trangAnBoat} titleImgText={t["vietnam.ninhBinh.trangAn.img"]} />
          {t["vietnam.ninhBinh.trangAn.p"]}
          <HighLightWrapper>{t["vietnam.ninhBinh.trangAn.highlight"]}</HighLightWrapper>
        </ParagraphBlock>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.ninhBinh.hangMua.title"]}</ParagraphTitle>
          <TitleImage src={muaCaveClimb} titleImgText={t["vietnam.ninhBinh.hangMua.img1"]} />
          <TitleImage src={muaCaveGoat} titleImgText={t["vietnam.ninhBinh.hangMua.img2"]} />
          <TitleImage src={muaCaveView} titleImgText={t["vietnam.ninhBinh.hangMua.img3"]} />
          {t["vietnam.ninhBinh.hangMua.p"]}
          <HighLightWrapper>{t["vietnam.ninhBinh.hangMua.highlight"]}</HighLightWrapper>
        </ParagraphBlock>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.ninhBinh.cycling.title"]}</ParagraphTitle>
          {t["vietnam.ninhBinh.cycling.p"]}
        </ParagraphBlock>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.ninhBinh.golf.title"]}</ParagraphTitle>
          <TitleImage src={ninhBinhGolf} titleImgText={t["vietnam.ninhBinh.golf.img"]} />
          {t["vietnam.ninhBinh.golf.p"]}
        </ParagraphBlock>
      </ParagraphBlock>

      <HeadingTitle>{t["vietnam.sapa.title"]}</HeadingTitle>
      <ParagraphBlock>{t["vietnam.sapa.arrival"]}</ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.sapa.homestay.title"]}</SecondHeadingTitle>
        <TitleImage src={sapaHomestayView} titleImgText={t["vietnam.sapa.homestay.img1"]} />
        <TitleImage src={sapaHomestayRoom} titleImgText={t["vietnam.sapa.homestay.img2"]} />
        {t["vietnam.sapa.homestay.p"]}
        <HighLightWrapper>{t["vietnam.sapa.homestay.highlight"]}</HighLightWrapper>
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.sapa.muongHoa.title"]}</SecondHeadingTitle>
        <TitleImage src={sapaLandscape} titleImgText={t["vietnam.sapa.muongHoa.img"]} />
        {t["vietnam.sapa.muongHoa.p"]}
      </ParagraphBlock>

      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.sapa.loop.title"]}</SecondHeadingTitle>
        {t["vietnam.sapa.loop.intro"]}
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.sapa.fansipan.title"]}</ParagraphTitle>
          <TitleImage src={sapaMist} titleImgText={t["vietnam.sapa.fansipan.img1"]} />
          <TitleImage src={fansipanSummit} titleImgText={t["vietnam.sapa.fansipan.img2"]} />
          {t["vietnam.sapa.fansipan.p"]}
          <HighLightWrapper>{t["vietnam.sapa.fansipan.highlight"]}</HighLightWrapper>
        </ParagraphBlock>
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.sapa.coaster.title"]}</ParagraphTitle>
          {t["vietnam.sapa.coaster.p"]}
        </ParagraphBlock>

      </ParagraphBlock>

      <HeadingTitle>{t["vietnam.hanoi.title"]}</HeadingTitle>
      <ParagraphBlock>{t["vietnam.hanoi.arrival"]}</ParagraphBlock>
      <ParagraphBlock>{t["vietnam.hanoi.propaganda.p"]}</ParagraphBlock>
      <ParagraphBlock>
        <SecondHeadingTitle>{t["vietnam.hanoi.oldQuarter.title"]}</SecondHeadingTitle>
        {t["vietnam.hanoi.oldQuarter.intro"]}
        <ParagraphBlock>
          <ParagraphTitle>{t["vietnam.hanoi.food.title"]}</ParagraphTitle>
          <ParagraphBlock>
            <TitleImage src={hanoiOysters} titleImgText={t["vietnam.hanoi.oysters.img"]} />
            <TitleImage src={hanoiXaShuNoodle} titleImgText={t["vietnam.hanoi.noodle.img"]} />
            {t["vietnam.hanoi.seafood.p"]}
          </ParagraphBlock>
          <ParagraphBlock>{t["vietnam.hanoi.coffee.p"]}</ParagraphBlock>
          <ParagraphBlock>
            <TitleImage src={hanoi4Ppizza} titleImgText={t["vietnam.hanoi.pizza.img"]} />
            <HighLightWrapper>4P's Pizza</HighLightWrapper> — {t["vietnam.hanoi.pizza.p"]}
          </ParagraphBlock>
        </ParagraphBlock>
      </ParagraphBlock>
      <ParagraphBlock>{t["vietnam.hanoi.departure"]}</ParagraphBlock>

      <HeadingTitle>{t["vietnam.summary.title"]}</HeadingTitle>
      <ParagraphBlock>
        {t["vietnam.summary.p"]}
        <HighLightWrapper>{t["vietnam.summary.highlight"]}</HighLightWrapper>
      </ParagraphBlock>
    </>
  );
};

export { VietnamItinerary };
